module.exports = __webpack_public_path__ + "img/receipt-24px.d382f096.svg";